var AssetDirectory = {
	"preloader": [
		"assets/font/preloader/exo-bold.ttf",
		"assets/font/preloader/exo-medium.ttf",
		"assets/font/preloader/proximanova-black.ttf",
		"assets/images/preloader/loader/gfx_bg.png",
		"assets/images/preloader/loader/gfx_loading.png",
		"assets/images/preloader/loader/gizmoloading.json",
		"assets/images/preloader/loader/gizmoloading_ske.json",
		"assets/images/preloader/loader/gizmoloading_tex.json",
		"assets/images/preloader/loader/gizmoloading_tex.png",
		"assets/sounds/preloader/loader/bgm/game_bgm.ogg",
		"assets/sounds/preloader/loader/sfx/button_sfx.ogg",
		"assets/sounds/preloader/loader/sfx/score_points.ogg",
		"assets/sounds/preloader/loader/sfx/star_gain.ogg",
		"assets/strings/preloader/strings.json"
	],
	"game": [
		"assets/images/external/game/ark.png",
		"assets/images/external/game/ark_joyandchris.png",
		"assets/images/external/game/bg_flood.png",
		"assets/images/external/game/deer/deer_anim_ske.json",
		"assets/images/external/game/deer/deer_anim_tex.json",
		"assets/images/external/game/deer/deer_anim_tex.png",
		"assets/images/external/game/deer2/deer2_anim_ske.json",
		"assets/images/external/game/deer2/deer2_anim_tex.json",
		"assets/images/external/game/deer2/deer2_anim_tex.png",
		"assets/images/external/game/donkey/donkey_anim_ske.json",
		"assets/images/external/game/donkey/donkey_anim_tex.json",
		"assets/images/external/game/donkey/donkey_anim_tex.png",
		"assets/images/external/game/flood.png",
		"assets/images/external/game/flood_cloud1.png",
		"assets/images/external/game/flood_cloud2.png",
		"assets/images/external/game/gazelle/gazelle_anim_ske.json",
		"assets/images/external/game/gazelle/gazelle_anim_tex.json",
		"assets/images/external/game/gazelle/gazelle_anim_tex.png",
		"assets/images/external/game/gizmo/gizmo_anim_ske.json",
		"assets/images/external/game/gizmo/gizmo_anim_tex.json",
		"assets/images/external/game/gizmo/gizmo_anim_tex.png",
		"assets/images/external/game/goat/goat_anim_ske.json",
		"assets/images/external/game/goat/goat_anim_tex.json",
		"assets/images/external/game/goat/goat_anim_tex.png",
		"assets/images/external/game/goat2/goat2_anim_ske.json",
		"assets/images/external/game/goat2/goat2_anim_tex.json",
		"assets/images/external/game/goat2/goat2_anim_tex.png",
		"assets/images/external/game/horse/horse_anim_ske.json",
		"assets/images/external/game/horse/horse_anim_tex.json",
		"assets/images/external/game/horse/horse_anim_tex.png",
		"assets/images/external/game/horse2/horse2_anim_ske.json",
		"assets/images/external/game/horse2/horse2_anim_tex.json",
		"assets/images/external/game/horse2/horse2_anim_tex.png",
		"assets/images/external/game/house1.png",
		"assets/images/external/game/house2.png",
		"assets/images/external/game/house3.png",
		"assets/images/external/game/house4.png",
		"assets/images/external/game/house5.png",
		"assets/images/external/game/house6.png",
		"assets/images/external/game/lamb/lamb_anim_ske.json",
		"assets/images/external/game/lamb/lamb_anim_tex.json",
		"assets/images/external/game/lamb/lamb_anim_tex.png",
		"assets/images/external/game/lightning1.png",
		"assets/images/external/game/lightning2.png",
		"assets/images/external/game/pickup/fx_pickup_ske.json",
		"assets/images/external/game/pickup/fx_pickup_tex.json",
		"assets/images/external/game/pickup/fx_pickup_tex.png",
		"assets/images/external/game/platform1.png",
		"assets/images/external/game/platform2.png",
		"assets/images/external/game/platform3.png",
		"assets/images/external/game/rain.png",
		"assets/images/external/game/ram/ram_anim_ske.json",
		"assets/images/external/game/ram/ram_anim_tex.json",
		"assets/images/external/game/ram/ram_anim_tex.png",
		"assets/images/external/game/splash/fx_splash_ske.json",
		"assets/images/external/game/splash/fx_splash_tex.json",
		"assets/images/external/game/splash/fx_splash_tex.png",
		"assets/images/external/game/wave/fx_flood_wave_ske.json",
		"assets/images/external/game/wave/fx_flood_wave_tex.json",
		"assets/images/external/game/wave/fx_flood_wave_tex.png",
		"assets/sounds/external/game/animal_collect.ogg",
		"assets/sounds/external/game/deer.ogg",
		"assets/sounds/external/game/donkey.ogg",
		"assets/sounds/external/game/fall_on_water_01.ogg",
		"assets/sounds/external/game/gazelle.ogg",
		"assets/sounds/external/game/goat.ogg",
		"assets/sounds/external/game/horse.ogg",
		"assets/sounds/external/game/jump.ogg",
		"assets/sounds/external/game/lamb.ogg",
		"assets/sounds/external/game/ram.ogg",
		"assets/sounds/external/game/success.ogg"
	],
	"title": [
		"assets/images/external/title/bg_logo_flood.png",
		"assets/images/external/title/logo_flood.png"
	],
	"ui": [
		"assets/images/external/ui/btn_audio1.png",
		"assets/images/external/ui/btn_audio2.png",
		"assets/images/external/ui/btn_audio3.png",
		"assets/images/external/ui/btn_audio4.png",
		"assets/images/external/ui/btn_exit.png",
		"assets/images/external/ui/btn_exit2.png",
		"assets/images/external/ui/btn_pause.png",
		"assets/images/external/ui/btn_pause2.png",
		"assets/images/external/ui/btn_play.png",
		"assets/images/external/ui/btn_play2.png",
		"assets/images/external/ui/btn_prevnext.png",
		"assets/images/external/ui/btn_prevnext2.png",
		"assets/images/external/ui/btn_replay.png",
		"assets/images/external/ui/btn_replay2.png",
		"assets/images/external/ui/btn_return.png",
		"assets/images/external/ui/btn_return2.png",
		"assets/images/external/ui/check-button1.png",
		"assets/images/external/ui/check-button2.png",
		"assets/images/external/ui/gfx_container.png",
		"assets/images/external/ui/gfx_container_white.png",
		"assets/images/external/ui/gfx_explode.png",
		"assets/images/external/ui/gfx_flare_long.png",
		"assets/images/external/ui/gfx_flare_star.png",
		"assets/images/external/ui/gfx_loading_bar_con.png",
		"assets/images/external/ui/gfx_pop.png",
		"assets/images/external/ui/gfx_pop2.png",
		"assets/images/external/ui/gfx_star0.png",
		"assets/images/external/ui/gfx_star1.png",
		"assets/images/external/ui/gfx_starbg.png",
		"assets/images/external/ui/htp_flood1.png",
		"assets/images/external/ui/htp_flood2.png",
		"assets/images/external/ui/htp_flood3.png",
		"assets/images/external/ui/htp_flood4.png",
		"assets/images/external/ui/htp_flood5.png",
		"assets/images/external/ui/htp_flood6.png",
		"assets/images/external/ui/x-button1.png",
		"assets/images/external/ui/x-button2.png"
	]
};